PegasusTemplate.TemplateRoute = Ember.Route.extend({
  activate: function(){
    PegasusTemplate.set('loaded', true);
  },
  deactivate: function(){
    PegasusTemplate.set('loaded', false);
  },
  model: function(params){
    return this.store.all(PegasusTemplate.WebTemplate).get('lastObject');
  },
  setupController: function(controller, model){
    $('.vr-opening').remove();
    this._super(controller, model);
  },
  renderTemplate: function(){
    this.render();
    var afterLoadMessage = PegasusTemplate.get('options').afterLoad;
    if ( afterLoadMessage ) {
      if ( afterLoadMessage.call ) {
        afterLoadMessage();
      } else {
        Em.run.scheduleOnce('afterRender', this, 'send', afterLoadMessage );
      }

      PegasusTemplate.set('options.afterLoad', null);
    }
  },
  actions: {
    hideOperations: function(){
      var blockOps = PegasusTemplate.lookupController('blockOperations');
      blockOps.set('content', null);
    },

    showPreview: function(){
      var callback = function(){
        $('.center-wrapper').imagesLoaded().
          always(function(){
            Em.run.scheduleOnce('afterRender', this, 'transitionTo', 'template.preview');
          }.bind(this));
      }.bind(this);

      if ( PegasusTemplate.stateMachine.get('currentPath') !== 'saved' ) {
        PegasusTemplate.Helpers.addOneTimeObserver( PegasusTemplate.stateMachine, 'currentPath', 'saved', callback );
        PegasusTemplate.stateMachine.send('didSave');
        return;
      }

      callback();
    },
    saveAndPreview: function(idObject){
      PegasusTemplate.loadedTemplate().set('insideHtmlPart', PegasusTemplate.canvasInstance.mutateForOut(null, true).editor_cookie );
      PegasusTemplate.set('canvasInstance', null);
      this.send('showPreview');
    },
    didLoadTemplate: Em.K
  }
});
